/**
 * The last issue list the user was looking at, so the detail page can show
 * "2 of 364" and step through the same result set (YouTrack behaviour).
 * Module state, not the store: it is navigation context, not data.
 */
export interface ListContext {
  query: string;
  ids: number[];
  total: number;
}

let current: ListContext = { query: "", ids: [], total: 0 };
const listeners = new Set<() => void>();

export function setListContext(next: ListContext): void {
  current = next;
  for (const l of listeners) l();
}
export function getListContext(): ListContext {
  return current;
}
export function subscribeListContext(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
